import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Search from "./common/Search";
import Sidebar from "./common/Sidebar";
import StickyMenu from "./common/StickyMenu";
import MobileMenu from "./common/MobileMenu";
import { Styles } from "./styles/headerTwo.js";
import { useAuth } from "../context/AuthContext";
import useSiteContent from "../hooks/useSiteContent";

const HeaderTwo = () => {
  const { user, logout } = useAuth();
  const history = useHistory();
  const header = useSiteContent("header");

  const handleLogout = () => {
    logout();
    history.push("/");
  };

  return (
    <Styles>
      {/* Topbar 2 */}
      <section className="top-bar2">
        <Container>
          <Row>
            <Col lg="7" md="9">
              <div className="bar-left">
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item">
                    <i className="las la-phone"></i>{header.phone}
                  </li>
                  <li className="list-inline-item">
                    <i className="las la-envelope"></i>{header.email}
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="5" md="3">
              <div className="bar-right d-flex justify-content-end">
                <ul className="list-unstyled list-inline sidebar-button">
                  <li className="list-inline-item nav-item side-box">
                    <Sidebar />
                  </li>
                </ul>
                <ul className="list-unstyled list-inline bar-login">
                  {user ? (
                    <>
                      <li className="list-inline-item">
                        <button
                          type="button"
                          className="auth-btn logout-btn"
                          onClick={handleLogout}
                        >
                          <i className="las la-sign-out-alt"></i>Logout
                        </button>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="list-inline-item">
                        <Link
                          to={process.env.PUBLIC_URL + "/login"}
                          className="auth-btn login-btn"
                        >
                          <i className="las la-user"></i>Log In
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          to={process.env.PUBLIC_URL + "/registration"}
                          className="auth-btn register-btn"
                        >
                          <i className="las la-user-edit"></i>Register
                        </Link>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Logo Area 2 */}
      <section className="logo-area2">
        <Container>
          <Row>
            <Col md="3">
              <div className="logo">
                <Link to={process.env.PUBLIC_URL + "/"}>
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Col>
            <Col md="9">
              <div className="menu-box d-flex justify-content-end">
                <ul className="nav menu-nav">
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/"}
                    >
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/about"}
                    >
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/courses"}
                    >
                      Courses
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/instructor"}
                    >
                      Instructor
                    </Link>
                  </li> */}
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/events"}
                    >
                      Events
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to={process.env.PUBLIC_URL + "/blog-grid"}
                    >
                      Blog
                    </Link>
                  </li>
                </ul>
                <div className="search-box d-none">
                  <Search />
                </div>
                {!user && (
                  <div className="apply-btn">
                    <Link to={process.env.PUBLIC_URL + "/registration"}>
                      <i className="las la-clipboard-list"></i>Apply Now
                    </Link>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Sticky Menu */}
      <StickyMenu user={user} />

      {/* Mobile Menu */}
      <MobileMenu />
    </Styles>
  );
};

export default HeaderTwo;
